import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import {
  GetSchedulerTasks,
  GetSchedulerTaskHistory,
  ClearSchedulerTaskHistory,
  GetSchedulerTaskById,
  CreateSchedulerTask,
  UpdateSchedulerTask,
  DeleteSchedulerTask,
  ChangeInactiveStatusSchedulerTask,
  ClearNextRunAtSchedulerTask,
} from './thunks';

import {
  GetSchedulerTasksReducer,
  GetSchedulerTaskHistoryReducer,
  ClearSchedulerTaskHistoryReducer,
  GetSchedulerTaskByIdReducer,
  CreateSchedulerTaskReducer,
  ResetSchedulerTasksStateReducer,
  ResetSelectedSchedulerTaskReducer,
  UpdateSchedulerTaskReducer,
  DeleteSchedulerTaskReducer,
  ChangeInactiveStatusSchedulerTaskReducer,
  ClearNextRunAtSchedulerTaskReducer,
} from './reducers';

// ----------------------------------------------------------------------------

export const schedulerSlice = createSlice({
  name: 'schedulerTasks',
  initialState,
  reducers: {
    ResetSchedulerTasks: ResetSchedulerTasksStateReducer,
    ResetSelectedTask: ResetSelectedSchedulerTaskReducer,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetSchedulerTasks, GetSchedulerTasksReducer);
    addExtraReducer(builder, GetSchedulerTaskHistory, GetSchedulerTaskHistoryReducer);
    addExtraReducer(builder, ClearSchedulerTaskHistory, ClearSchedulerTaskHistoryReducer);
    addExtraReducer(builder, GetSchedulerTaskById, GetSchedulerTaskByIdReducer);
    addExtraReducer(builder, CreateSchedulerTask, CreateSchedulerTaskReducer);
    addExtraReducer(builder, UpdateSchedulerTask, UpdateSchedulerTaskReducer);
    addExtraReducer(builder, DeleteSchedulerTask, DeleteSchedulerTaskReducer);
    addExtraReducer(builder, ChangeInactiveStatusSchedulerTask, ChangeInactiveStatusSchedulerTaskReducer);
    addExtraReducer(builder, ClearNextRunAtSchedulerTask, ClearNextRunAtSchedulerTaskReducer);
  },
});

export default schedulerSlice.reducer;
